module.exports = __webpack_public_path__ + "img/AT0000002674222.90414ee6.png";